import { render } from "./FileItem.vue?vue&type=template&id=3c4534c7&scoped=true"
import script from "./FileItem.vue?vue&type=script&lang=js"
export * from "./FileItem.vue?vue&type=script&lang=js"

import "./FileItem.vue?vue&type=style&index=0&id=3c4534c7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c4534c7"]])

export default __exports__